import { createI18n } from 'vue-i18n'

// 英文语言包
import en from './locales/en.json'
// 中文语言包
import zh from './locales/zh.json'

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: 'en', // 默认语言为英文
  fallbackLocale: 'en', // 回退语言
  messages: {
    en,
    zh
  }
})

// Custom composable for i18n
export function useI18n() {
  const { t, locale } = i18n.global

  const setLocale = (newLocale: 'en' | 'zh') => {
    locale.value = newLocale
    localStorage.setItem('user-locale', newLocale)
  }

  const initLocale = () => {
    const savedLocale = localStorage.getItem('user-locale') as 'en' | 'zh'
    if (savedLocale && ['en', 'zh'].includes(savedLocale)) {
      locale.value = savedLocale
    } else {
      locale.value = 'en' // Default to English if no valid saved locale
      localStorage.setItem('user-locale', 'en')
    }
  }

  return {
    t,
    locale,
    setLocale,
    initLocale
  }
}

export default i18n
